import useMapCentering from '../../hooks/useMapCentering';
import BaseMap from './BaseMap';

function MapWithCentering({ defaultCenter, defaultZoom, selectedMarker, isEditable, onClick, children }) {
    useMapCentering(selectedMarker);

    return (
        <BaseMap
            defaultCenter={defaultCenter}
            defaultZoom={defaultZoom}
            mapID={process.env.REACT_APP_GOOGLE_MAPS_MAP_ID}
            isEditable={isEditable}
            onClick={onClick}>
            {children}
        </BaseMap>
    );
}

export default MapWithCentering;